import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { ArrowLongRightSvg } from './ArrowLongRight';

export const ArrowLongRightIcon = createIcon('arrowLongRight', ArrowLongRightSvg);
/**
 * @deprecated используйте ArrowLongRightIcon
 */
export const withArrowLongRightIcon = withIcon('arrowLongRight', ArrowLongRightSvg);
